import React, { useContext } from 'react';
import { LightgalleryItem } from 'react-lightgallery';
import resizeImage from '../../utils/resizeImage';
import { Context } from '../../context/AppContext';

const ImageLightboxItem = ({ image, caption, children, group }) => {
  const {
    webp,
    media: { mobile },
  } = useContext(Context);

  const shareUrl = resizeImage(image, {
    width: 900,
    height: 900,
    quality: 100,
    webp,
  });

  const imageUrl = resizeImage(image, {
    width: mobile ? 400 : 800,
    height: mobile ? 400 : 800,
    quality: 70,
    webp,
  });

  const thumbnailUrl = resizeImage(image, {
    width: 80,
    height: 80,
    fit: 'cover',
    quality: 50,
    webp,
  });

  return (
    <LightgalleryItem
      group={group}
      src={imageUrl}
      thumb={thumbnailUrl}
      pinterestShareUrl={shareUrl}
      twitterShareUrl={shareUrl}
      facebookShareUrl={shareUrl}
      pinterestText={caption}
      tweetText={caption}
      {...(caption && typeof caption === 'string'
        ? {
            subHtml: caption,
          }
        : {})}
    >
      {children}
    </LightgalleryItem>
  );
};

export default ImageLightboxItem;
